




































































































import Enumerable from "linq";
import { IFormatAlert } from "../../../../domain/editableFormat";
import { IConfiguration } from "../../../../domain/configuration";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "../../../../../base/components/developer/mixins";
import {
  CacheableComponent,
  NotImplementedComponent,
} from "../../../../../base/components/system";
import {
  ModelEditableMixin,
  TabContainableMixin
} from "../../../../../base/components/system/mixins";
import {
  TabSelector,
} from "../../../../../base/components/system/selectors";
import { FormatEditorDebugTool } from "../../../developer";
import { FormatStructureEditableMixin } from "../mixins";
import {
  FormatObjectEditTool,
  FormatObjectListTool,
  FormatObjectNameWarningTool,
  FormatPropertyEditTool,
  FormatPagePropertyEditTool,
  FormatNewPagePropertyEditTool,
  FormatCurrentPagePropertyEditTool,
  FormatPageBackgroundImageEditTool,
  FormatCreatedFormatTool,
  FormatAlertTool,
} from "./tools";

interface ITabDefinition {
  name: string;
  description: string;
  width: number;
  height: number;
  title: string;
}

@Component({
  components: {
    TabSelector,
    CacheableComponent,
    FormatObjectEditTool,
    FormatObjectListTool,
    FormatObjectNameWarningTool,
    FormatPropertyEditTool,
    FormatPagePropertyEditTool,
    FormatNewPagePropertyEditTool,
    FormatCurrentPagePropertyEditTool,
    FormatPageBackgroundImageEditTool,
    FormatCreatedFormatTool,
    FormatAlertTool,
    FormatEditorDebugTool,
    NotImplementedComponent,
  },
})
export default class FormatToolContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin, TabContainableMixin, DeveloperPresentableMixin) {
  $configuration!: IConfiguration;

  static readonly Tabs = {
    edit: {
      name: "edit",
      description: "フォーマットにオブジェクトを追加／編集するツールパレットを表示します。",
      width: 400,
      height: 400,
      title: "オブジェクト属性",
    },
    currentPage: {
      name: "currentPage",
      description: "現在ページの属性を確認/編集できます。",
      width: 400,
      height: 400,
      title: "現在ページ属性",
    },
    page: {
      name: "page",
      description: "選択中ページの属性を確認/編集できます。",
      width: 400,
      height: 400,
      title: "ページ属性",
    },
    backgroundImage: {
      name: "backgroundImage",
      description: "下地画像をページに反映できます。",
      width: 400,
      height: 400,
      title: "下地画像",
    },
    newPage: {
      name: "newPage",
      description: "新規ページを追加できます。",
      width: 400,
      height: 400,
      title: "新規ページ",
    },
    format: {
      name: "format",
      description: "編集中フォーマットの情報を確認/編集できます。",
      width: 400,
      height: 400,
      title: "フォーマット属性",
    },
    objectList: {
      name: "objectList",
      description: "ページ内オブジェクトを一覧で確認できます。選択や並べ替えもできます。",
      width: 400,
      height: 400,
      title: "オブジェクト一覧",
    },
    nameWarning: {
      name: "nameWarning",
      description: "オブジェクトの名称警告を確認/編集できます。",
      width: 400,
      height: 400,
      title: "名称警告",
    },
    schema: {
      name: "schema",
      description: "シェーマの一覧を表示します。フォーマットにシェーマを貼り付けることもできます。",
      width: 400,
      height: 400,
      title: "シェーマ",
    },
    createdFormat: {
      name: "createdFormat",
      description: "作成済の他のフォーマットを参照します。",
      width: 600,
      height: 400,
      title: "参照",
    },
    alert: {
      name: "alert",
      description: "発生した警告を一覧で表示します。登録前の事前検証もできます。",
      width: 600,
      height: 400,
      title: "警告確認",
    },
    debug: {
      name: "debug",
      description: "オブジェクトの情報を表示します。デバッグモードの時のみ表示されます。",
      width: 600,
      height: 400,
      title: "debug",
    },
  };

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly editTab: ITabDefinition = FormatToolContainer.Tabs.edit;
  readonly currentPageTab: ITabDefinition = FormatToolContainer.Tabs.currentPage;
  readonly pageTab: ITabDefinition = FormatToolContainer.Tabs.page;
  readonly backgroundImageTab: ITabDefinition = FormatToolContainer.Tabs.backgroundImage;
  readonly newPageTab: ITabDefinition = FormatToolContainer.Tabs.newPage;
  readonly formatTab: ITabDefinition = FormatToolContainer.Tabs.format;
  readonly objectListTab: ITabDefinition = FormatToolContainer.Tabs.objectList;
  readonly nameWarningTab: ITabDefinition = FormatToolContainer.Tabs.nameWarning;

  readonly schemaTab: ITabDefinition = FormatToolContainer.Tabs.schema;
  readonly createdFormatTab: ITabDefinition = FormatToolContainer.Tabs.createdFormat;
  readonly alertTab: ITabDefinition = FormatToolContainer.Tabs.alert;
  readonly debugTab: ITabDefinition = FormatToolContainer.Tabs.debug;

  @Prop()
  enableTabs: ITabDefinition[];

  @Prop({ default: "right" })
  tabPosition: string;

  @Prop()
  defaultTab: ITabDefinition;

  get containerClass(): string | (string[]) {
    return [
      "tool-container-root",
      "tool-container-root-" + this.tabPosition,
    ];
  }

  get containerStyleProperties() {
    return {
      width: this.selectedTab ? (this.isLayoutHorizontal ? (this.selectedTab as any).width + "px" : "100%") : null,
      height: this.selectedTab ? (this.isLayoutHorizontal ? "100%" : (this.selectedTab as any).height + "px") : null,
    };
  }

  get isLayoutHorizontal(): boolean {
    return (this.tabPosition === "right")
        || (this.tabPosition === "left");
  }

  get tabLayoutClass(): string {
    return !this.isLayoutHorizontal
      ? "horizontal"
      : "vertical";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  created(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = Enumerable.from([
      this.isEditEnable ? FormatToolContainer.Tabs.edit : null,
      this.isCurrentPageEnable ? FormatToolContainer.Tabs.currentPage : null,
      this.isPageEnable ? FormatToolContainer.Tabs.page : null,
      this.isBackgroundImageEnable ? FormatToolContainer.Tabs.backgroundImage : null,
      this.isNewPageEnable ? FormatToolContainer.Tabs.newPage : null,
      this.isFormatEnable ? FormatToolContainer.Tabs.format : null,
      this.isObjectListEnable ? FormatToolContainer.Tabs.objectList : null,
      this.isNameWarningEnable ? FormatToolContainer.Tabs.nameWarning : null,
      this.isSchemaEnable ? FormatToolContainer.Tabs.schema : null,
      this.isCreatedFormatEnable ? FormatToolContainer.Tabs.createdFormat : null,
      this.isAlertEnable ? FormatToolContainer.Tabs.alert : null,
      this.isDebugEnable ? FormatToolContainer.Tabs.debug : null,
    ]).where(t => !!t).toArray();
    this.selectedTab = this.defaultTab;
  }

  private get isEditEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.edit);
  }

  private get isCurrentPageEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.currentPage) && !this.isQuestionnaireEditable;
  }

  private get isPageEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.page) && !this.isQuestionnaireEditable;
  }

  private get isBackgroundImageEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.backgroundImage);
  }

  private get isNewPageEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.newPage) && !this.isQuestionnaireEditable;
  }

  private get isFormatEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.format);
  }

  private get isObjectListEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.objectList);
  }

  private get isNameWarningEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.nameWarning);
  }

  private get isSchemaEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.schema);
  }

  private get isDebugEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.debug) && this.isDeveloperMode;
  }

  private get isCreatedFormatEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.createdFormat);
  }

  private get isAlertEnable(): boolean {
    return this.containsTab(FormatToolContainer.Tabs.alert);
  }

  private containsTab(tab: any): boolean {
    return (0 <= this.enableTabs.indexOf(tab));
  }

  @Watch("isDeveloperMode")
  onDeveloperModeUpdated(newValue: boolean, oldValue: boolean): void {
    this.initializeTabs();
  }

  @Watch("alerts")
  onAlertsUpdated(newValue: IFormatAlert[], oldValue: IFormatAlert[]): void {
    if (this.isAlertEnable && (newValue !== oldValue) && newValue && Enumerable.from(newValue).any(a => !!a)) {
      this.selectedTab = FormatToolContainer.Tabs.alert;
    }
  }
}
